/* ========================================================================
//	GENERIC
======================================================================== */

(function ($) {
	
	
	
	MyTools.initPg('GENERIC');
	
})(jQuery, MyTools);
